import { Controller } from "@hotwired/stimulus"

import { createFragment, hide, show } from "../lib/helpers"

export default class extends Controller {
  static targets = ['content', 'moreButton', 'lessButton']
  static values = {
    truncateLength: {
      type: Number,
      default: 30
    },
    truncateOmission: {
      type: String,
      default: "…"
    },
    truncatedContent: String,
    defaultToShowMore: Boolean
  }

  initialize() {
    this.originalContent = this.contentTarget.innerHTML
    // Assigning the derived snippet below writes it back onto the data
    // attribute, so remember now whether the server provided one.
    this.serverProvidesTruncatedContent = !!this.truncatedContentValue
    this.truncatedContentValue = this.truncatedContentValue || this.textTruncatedContent()
  }

  connect() {
    // A morph rewrites the content to the server-rendered full text without
    // reconnecting the controller — re-capture and re-truncate. A derived
    // snippet must also be re-derived from the new content, or the collapsed
    // view would keep showing the stale pre-morph snippet.
    this.morphHandler = () => {
      this.originalContent = this.contentTarget.innerHTML

      if (!this.serverProvidesTruncatedContent) {
        this.truncatedContentValue = this.textTruncatedContent()
      }

      this.apply()
    }
    document.addEventListener("turbo:morph", this.morphHandler)

    this.apply()
  }

  apply() {
    if (!this.shouldTruncate) {
      this.hideAllButtons()

      return
    }

    this.render()
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.morphHandler)
    this.contentTarget.innerHTML = this.originalContent;
  }

  render() {
    if (this.defaultToShowMoreValue) {
      this.showMore()
    } else {
      this.showLess()
    }
  }

  get shouldTruncate() {
    const originalContentLength = createFragment(this.contentTarget.innerHTML).textContent.trim().length
    const truncatedContentLength = createFragment(this.truncatedContentValue).textContent.trim().length

    return (originalContentLength > truncatedContentLength)
  }

  showMore() {
    this.contentTarget.innerHTML = this.originalContent

    hide(this.moreButtonTarget)
    show(this.lessButtonTarget)
  }

  showLess() {
    this.contentTarget.innerHTML = this.truncatedContentValue

    hide(this.lessButtonTarget)
    show(this.moreButtonTarget)
  }

  hideAllButtons() {
    hide(this.moreButtonTarget)
    hide(this.lessButtonTarget)
  }

  textTruncatedContent() {
    return this.contentTarget.textContent.substring(0, this.truncateLengthValue) + this.truncateOmissionValue
  }
}
